module.exports = __webpack_public_path__ + "static/media/qr_wl_new.2f56fce5.png";